export const normalizeProjectUuid = (value) => {
  const text = value == null ? '' : String(value).trim();
  if (!text) return null;

  const uuidPattern =
    /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}/;
  const match = text.match(uuidPattern);
  return match ? match[0].toLowerCase() : null;
};

export const getProjectContext = () => {
  const rawProjectUid = localStorage.getItem('project_uuid');
  const projectUuid = normalizeProjectUuid(rawProjectUid);

  return {
    project_uuid: projectUuid,
  };
};

export const withProjectContext = (payload = {}) => {
  const nextPayload = { ...payload };
  const { project_uuid } = getProjectContext();

  const payloadUuid = normalizeProjectUuid(nextPayload.project_uuid);
  if (payloadUuid) {
    nextPayload.project_uuid = payloadUuid;
    return nextPayload;
  }

  if (project_uuid) {
    nextPayload.project_uuid = project_uuid;
  }

  return nextPayload;
};

